import axionIns from "../axios";

const getSubscriptonPlan = async (companyId, page, limit, type = '') => {
  return axionIns
    .get(
      `subscriptionplan/${companyId}?page=${page}&perPage=${limit ? limit : 50}&type=${type}`
    )
    .then((response) => {
      return response.data;
    });
};

const getSingleSubscriptonPlan = async (companyId, planId) => {
  return axionIns
    .get(`subscriptionplan/${companyId}/${planId}`)
    .then((response) => {
      return response.data;
    });
};

const addSubscription = (payload) => {
  return axionIns.post("user/cutomsubscriptionplan", payload).then((response) => {
    return response.data;
  });
};


const previewSubscription = (payload) => {
  return axionIns.post("user/customsubscriptionplan/preview", payload).then((response) => {
    return response.data;
  });
};

const createBusinessPlan = (companyId, payload) => {
  return axionIns.post(`subscriptionplan/${companyId}/businessplan`, payload).then((response) => {
    return response.data;
  });
};

const comparePlans = (payload) => {
  return axionIns.post("plans/compare", payload).then((response) => {
    return response.data;
  });
};

const exportOject = {
  getSubscriptonPlan,
  getSingleSubscriptonPlan,
  addSubscription,
  previewSubscription,
  createBusinessPlan,
  comparePlans,
};

export default exportOject;
